function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* eslint-disable max-len */
import { chakra } from '@chakra-ui/system';
import React, { useEffect, useRef } from 'react';
import * as Styles from '../styles/styles';
import { TIME_RANGE } from './consts';
export var DRTPTimePicker = props => {
  var listItemRefs = useRef([]); // reset to next avail time, when value is within unavailableTimes

  useEffect(() => {
    if (!props.unavailableTimes.length) return;
    if (!props.unavailableTimes.includes(props.value)) return;
    var nextAvailTime = TIME_RANGE.find(T => !props.unavailableTimes.includes(T.value));
    if (!nextAvailTime) return;
    props.onSelect(nextAvailTime == null ? void 0 : nextAvailTime.value);
  }, [props.value, props.unavailableTimes]); // scroll to offset of selected time

  useEffect(() => {
    var _targetItem$parentEle;

    if (!listItemRefs.current.length) return;
    var targetItem = listItemRefs.current.find((_, index) => index === props.value);
    if (!targetItem) return;
    (_targetItem$parentEle = targetItem.parentElement) == null ? void 0 : _targetItem$parentEle.scrollTo({
      behavior: 'smooth',
      top: targetItem.offsetTop - targetItem.parentElement.offsetTop - 50
    });
  }, [props.value, listItemRefs]);
  return /*#__PURE__*/React.createElement(Styles.TimeContainer, null, /*#__PURE__*/React.createElement(chakra.div, {
    height: "15px"
  }), TIME_RANGE.map(TIME => {
    var isDisabled = props.unavailableTimes.some(UT => UT === TIME.value);
    var isActive = props.value === TIME.value;
    return /*#__PURE__*/React.createElement(Styles.TimeButton, {
      disabled: isDisabled,
      key: "time-" + TIME.value,
      onClick: e => {
        e.preventDefault();
        props.onSelect(TIME.value);
      },
      ref: node => listItemRefs.current[TIME.value] = node,
      sx: _extends({}, isActive && {
        background: 'brand.500',
        color: 'white'
      }, isDisabled && {
        opacity: 0.5,
        cursor: 'not-allowed'
      }),
      value: TIME.value
    }, TIME.label);
  }), /*#__PURE__*/React.createElement(chakra.div, {
    height: "40px"
  }));
};
//# sourceMappingURL=time-picker.js.map